import React, { Fragment, useState } from "react";
import cartImage from "../assets/Images/cart_icon.svg";
import closeIcon from "../assets/Images/close_icon.svg";
import api from "../services/api";
import { toast, ToastContainer } from "react-toastify";
import CustomInput from "./CustomInput";
import Loader from "./Loader";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../components/context/UserContext";

function BuyerPopup({
  productId,
  buyerValue,
  productType,
  fetchPlots,
  locationId,
}) {
  const [loading, setIsLoading] = useState(false);
  const [openAddBuyers, setOpenAddBuyers] = useState(false);
  const handleOpenBuyersDetail = () => {
    setOpenAddBuyers(true);
  };

  const fullAddress = {
    country: "",
    houseName: "",
    street: "",
    county: "",
    townOrCity: "",
  };
  const initialValues = {
    firstName: "",
    lastName: "",
    postalCode: "",
    email: "",
    contactNumber: {
      dialCode: "+44",
      number: "",
    },
    amount: "",
    ...fullAddress,
  };

  const [postCodeToggle, setPostCodetoggle] = useState(true);
  const [activeStates, setActiveStates] = useState([true, false]);
  const [formData, setFormData] = useState(initialValues);
  const [buyerFormData, setBuyerFormData] = useState(initialValues);
  const [submittedBy, setSubmittedBy] = useState(0);
  const [postCodeSuggestion, setPostCodeSuggestion] = useState([]);
  const [postCodeLoading, setPostCodeLoading] = useState(false);
  const navigate = useNavigate();
  const [amount, setAmount] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const { state } = useUserContext();

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const getPostCodeValue = async (postCode) => {
    try {
      setPostCodeLoading(true);
      let res = await api.getPostCodeSuggestion(postCode);
      console.log(res);
      if (res?.status) {
        setPostCodeSuggestion(res?.data?.suggestions);
        setPostCodeLoading(false);
      }
    } catch (error) {
      setPostCodeLoading(false);
    }
  };

  const handlePostCode = () => {
    setPostCodetoggle(!postCodeToggle);
  };

  const handleClick = (idx) => {
    const newActiveStates = activeStates.map((state, i) => i === idx);
    setActiveStates(newActiveStates);
    setSubmittedBy(idx);
    setPostCodeSuggestion([]);
  };

  const handleFormData = async (e) => {
    const { name, value } = e.target;
    if (name === "contactNumber") {
      // Update the key check
      if (value?.length > 11) return; // Limit to 11 characters
      setFormData((prevData) => ({
        ...prevData,
        contactNumber: {
          ...prevData.contactNumber, // Preserve dialCode
          number: value, // Update the number
        },
      }));
      return;
    }
    if (name === "postalCode") {
      getPostCodeValue(value);
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleBuyerFormData = (e) => {
    const { name, value } = e.target;
    if (name === "contactNumber") {
      // Update the key check
      if (value?.length > 11) return; // Limit to 11 characters
      setBuyerFormData((prevData) => ({
        ...prevData,
        contactNumber: {
          ...prevData.contactNumber, // Preserve dialCode
          number: value, // Update the number
        },
      }));
      return;
    }
    if (name === "postalCode") {
      getPostCodeValue(value);
    }
    setBuyerFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleClickNext = async () => {
    const currentFormData = submittedBy === 0 ? formData : buyerFormData;

    for (const key in currentFormData) {
      if (!currentFormData[key]) {
        toast.error("Please fill in all required fields before proceeding.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
    }

    // Check for email validity
    if (!emailRegex.test(currentFormData.email)) {
      toast.error("Please enter a valid email address.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    let formDataIsEmpty = false;
    if (submittedBy != 0) {
      for (const key in formData) {
        if (!formData[key]) {
          formDataIsEmpty = true;
          break;
        }
      }
    }

    if (formDataIsEmpty) {
      toast.error("Buyer One information is mandatory.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    let allBuyerData = [];
    if (submittedBy === 0) {
      // If the current form data is buyer 1 (formData), store it
      allBuyerData.push(formData);
    } else {
      // If the current form data is buyer 2 (buyerFormData), store both buyer data objects
      allBuyerData.push(formData);
      allBuyerData.push(buyerFormData);
    }

    await handleBuyCustomerPlot(allBuyerData);
  };

  const handlePostCodeAddress = async (id) => {
    setPostCodetoggle(false);
    setPostCodeSuggestion([]);
    try {
      let res = await api.getAddress(id);
      if (res.status) {
        const data = await res?.data?.data;
        let street = await data?.thoroughfare;
        let houseName =
          data?.line_1?.length == 1
            ? data?.line_1 + " " + data?.line_2
            : data?.line_1;
        if (houseName && houseName !== street) {
          houseName = houseName.replace(street, " ");
        }

        if (submittedBy === 0) {
          setFormData({
            ...formData,
            country: data?.country,
            townOrCity: data?.town_or_city,
            county: data?.county,
            houseName: houseName,
            street: data?.thoroughfare,
            postalCode: data?.postcode,
          });
        } else {
          setBuyerFormData({
            ...buyerFormData,
            country: data?.country,
            townOrCity: data?.town_or_city,
            county: data?.county,
            houseName: houseName,
            street: data?.thoroughfare,
            postalCode: data?.postcode,
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleBuyCompanyPlot = async (e) => {
    e.preventDefault();

    const data = {
      productId: productId,
      productType: productType,
      quantity: 1,
    };
    try {
      setIsLoading(true);

      const response = await api.buyCompanyPlot(data, state?.token);

      setIsLoading(false);
      setOpenAddBuyers(false);
      buyerValue(0);
      navigate("/plotsManagement");
      toast.success(response?.data?.message);
      fetchPlots(locationId);
    } catch (error) {
      console.error("Error:", error);
      toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePaymentMethodChange = (e) => {
    setPaymentMethod(e.target.value);
  };

  const handleBuyCustomerPlot = async (buyersData, e) => {
    e?.preventDefault();

    const modifiedBuyersData = buyersData.map((buyer, index) => {
      if (index === 0) {
        return { ...buyer, type: "Buyer 1" };
      } else if (index === 1) {
        return { ...buyer, type: "Buyer 2" };
      }
      return buyer;
    });
    // if (!amount) {
    //   toast.error("Please enter a valid amount!");
    //   return;
    // }

    if (!paymentMethod) {
      toast.error("Please select a payment method!");
      return;
    }

    const data = {
      buyerAddress: modifiedBuyersData,
      items: {
        productId: productId,
        productType: productType,
        quantity: 1,
        amountPaid: parseFloat(formData.amount),
        paymentMethod: paymentMethod,
      },
    };
    try {
      setIsLoading(true);

      const response = await api.buyCustomerPlot(data, state?.token);
      console.log(response, "buy request completed");

      setIsLoading(false);
      setOpenAddBuyers(false);
      buyerValue(0);
      fetchPlots(locationId);
      toast.success(response?.data?.message);
    } catch (error) {
      console.error("Error:", error);
      toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClosePopup = () => {
    setOpenAddBuyers(false);
    buyerValue(0);
  };

  return (
    <Fragment>
      <div
        style={{ position: "fixed" }}
        className="overlay buyers-main-active"
      />
      {!openAddBuyers ? (
        <>
          <div class="">
            <div class="cart_main company_popup">
              <div className="button-div">
                <button
                  onClick={handleClosePopup}
                  className="buyer_close-popup"
                >
                  <img src={closeIcon} />
                </button>
              </div>
              <div>
                <img src={cartImage} alt="" />
              </div>
              <span>Please confirm!</span>
              <p>Buy this plot for ?</p>
              <div className="buyer-popup_button">
                <button
                  style={{ width: "140px", whiteSpace: "nowrap" }}
                  onClick={handleBuyCompanyPlot}
                  class="no-btn"
                >
                  {loading ? (
                    <div className="edit_loader-one"></div>
                  ) : (
                    "For Company"
                  )}
                </button>
                <button
                  style={{ whiteSpace: "nowrap" }}
                  onClick={handleOpenBuyersDetail}
                  class="yes-btn"
                >
                  For Customer
                </button>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="buyers-main">
          <button className="closeBtn" onClick={handleClosePopup}>
            <img src={closeIcon} alt="close btn" />
          </button>
          <h2>Add buyer’s details</h2>
          <div className="head">
            <p>
              <span
                className={activeStates[0] ? "active-data" : ""}
                onClick={() => handleClick(0)}
              >
                Buyer 1 <b>*</b>
              </span>
              <span
                className={activeStates[1] ? "active-data" : ""}
                onClick={() => handleClick(1)}
              >
                Buyer 2 (optional)
              </span>
            </p>
          </div>
          <div className="input-group">
            <div className="input-field input-pin">
              <div className="input-code">
                {/* <label>Full Name <span>{submittedBy === 0 ? '*' :''}</span></label> */}
                <CustomInput
                  type={"text"}
                  name="firstName"
                  value={
                    submittedBy === 0
                      ? formData.firstName
                      : buyerFormData.firstName
                  }
                  label={"First name"}
                  handleChange={
                    submittedBy === 0 ? handleFormData : handleBuyerFormData
                  }
                />
              </div>
              <div className="input-code">
                {/* <label>Full Name <span>{submittedBy === 0 ? '*' :''}</span></label> */}
                <CustomInput
                  type={"text"}
                  name="lastName"
                  value={
                    submittedBy === 0
                      ? formData.lastName
                      : buyerFormData.lastName
                  }
                  label={"Last name"}
                  handleChange={
                    submittedBy === 0 ? handleFormData : handleBuyerFormData
                  }
                />
              </div>
            </div>

            <div className="input-field input-pin">
              <div className="input-code">
                {/* <label>Email Address <span>{submittedBy === 0 ? '*' :''}</span></label> */}
                <CustomInput
                  type={"email"}
                  name="email"
                  value={
                    submittedBy === 0 ? formData.email : buyerFormData.email
                  }
                  label={"Your email address"}
                  handleChange={
                    submittedBy === 0 ? handleFormData : handleBuyerFormData
                  }
                />
              </div>

              <div className="input-code">
                {/* <label>Contact Number <span>{submittedBy === 0 ? '*' :''}</span></label> */}
                <CustomInput
                  name="contactNumber"
                  type="number"
                  value={
                    submittedBy === 0
                      ? formData?.contactNumber?.number
                      : buyerFormData?.contactNumber?.number
                  }
                  label={"Contact number"}
                  handleChange={
                    submittedBy === 0 ? handleFormData : handleBuyerFormData
                  }
                />
              </div>
            </div>

            <div className="address">
              <label htmlFor="" className="address-heading">
                Address
              </label>
              <div className="address-type">
                <ul>
                  <li
                    onClick={handlePostCode}
                    className={`${postCodeToggle ? "active-data" : ""}`}
                  >
                    Postcode Finder
                  </li>
                  <li
                    onClick={handlePostCode}
                    className={`${postCodeToggle ? "" : "active-data"}`}
                  >
                    Enter Manually
                  </li>
                </ul>
                {postCodeToggle ? (
                  <div className="address-fields new-amount-field active-data">
                    <div className="input-code">
                      <CustomInput
                        name="postalCode"
                        type="text"
                        value={
                          submittedBy === 0
                            ? formData.postalCode
                            : buyerFormData.postalCode
                        }
                        label={"Enter your postcode"}
                        handleChange={
                          submittedBy === 0
                            ? handleFormData
                            : handleBuyerFormData
                        }
                      />
                    </div>

                    {postCodeSuggestion?.length > 0 && formData.postalCode && (
                      <>
                        <div className="postcode-bar">
                          {postCodeLoading ? (
                            <Loader />
                          ) : (
                            <ul>
                              {postCodeSuggestion?.map((value) => {
                                return (
                                  <li
                                    onClick={() =>
                                      handlePostCodeAddress(value?.id)
                                    }
                                  >
                                    {value?.address.replace(
                                      /^(\d+),\s*/,
                                      "$1 "
                                    )}
                                  </li>
                                );
                              })}
                            </ul>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                ) : (
                  <div className="address-fields">
                    <div className="input-field new-amount-field input-pin">
                      <div className="input-code">
                        <CustomInput
                          type={"text"}
                          name="houseName"
                          value={
                            submittedBy === 0
                              ? formData.houseName
                              : buyerFormData.houseName
                          }
                          label={"House Name"}
                          handleChange={
                            submittedBy === 0
                              ? handleFormData
                              : handleBuyerFormData
                          }
                        />
                      </div>
                      <div className="input-code">
                        <CustomInput
                          name="street"
                          type="text"
                          value={
                            submittedBy === 0
                              ? formData.street
                              : buyerFormData.street
                          }
                          label={"Street"}
                          handleChange={
                            submittedBy === 0
                              ? handleFormData
                              : handleBuyerFormData
                          }
                        />
                      </div>
                    </div>
                    <div className="input-field input-pin">
                      <div className="input-code">
                        <CustomInput
                          type={"text"}
                          name="townOrCity"
                          value={
                            submittedBy === 0
                              ? formData.townOrCity
                              : buyerFormData.townOrCity
                          }
                          label={"Town/City"}
                          handleChange={
                            submittedBy === 0
                              ? handleFormData
                              : handleBuyerFormData
                          }
                        />
                      </div>
                      <div className="input-code">
                        <CustomInput
                          name="county"
                          type="text"
                          value={
                            submittedBy === 0
                              ? formData.county
                              : buyerFormData.county
                          }
                          label={"County"}
                          handleChange={
                            submittedBy === 0
                              ? handleFormData
                              : handleBuyerFormData
                          }
                        />
                      </div>
                    </div>
                    <div className="input-field input-pin">
                      <div className="input-code">
                        <CustomInput
                          type={"text"}
                          name="postalCode"
                          value={
                            submittedBy === 0
                              ? formData.postalCode
                              : buyerFormData.postalCode
                          }
                          label={"Post Code"}
                          handleChange={
                            submittedBy === 0
                              ? handleFormData
                              : handleBuyerFormData
                          }
                        />
                      </div>
                      <div className="input-code">
                        <CustomInput
                          name="country"
                          type="text"
                          value={
                            submittedBy === 0
                              ? formData.country
                              : buyerFormData.country
                          }
                          label={"Country"}
                          handleChange={
                            submittedBy === 0
                              ? handleFormData
                              : handleBuyerFormData
                          }
                        />
                      </div>
                    </div>
                    {activeStates[0] && (
                      <>
                        <div className="input-field input-pin">
                          <h5>Payment Status</h5>
                        </div>
                        <div className="input-field input-pin">
                          <div className="input-code">
                            <CustomInput
                              type={"text"}
                              name="amount"
                              value={
                                submittedBy === 0
                                  ? formData.amount
                                  : buyerFormData.amount
                              }
                              label={"Enter amount ($)"}
                              handleChange={
                                submittedBy === 0
                                  ? handleFormData
                                  : handleBuyerFormData
                              }
                              readOnly={submittedBy !== 0}
                            />
                          </div>
                          <div className="input-code">
                            <select
                              name="paymentMethod"
                              value={paymentMethod}
                              onChange={handlePaymentMethodChange}
                            >
                              <option value={""} readOnly>
                                Select Payment Method
                              </option>
                              <option value={"bank_transfer_full_payment"}>
                                Bank Transfer Full Payment
                              </option>
                              <option value="card_full_payment">
                                Card Full Payment
                              </option>
                              <option value="bank_transfer_finance">
                                Bank Transfer Finance
                              </option>
                              <option value="card_transfer_finance">
                                Card Payment Finance
                              </option>
                            </select>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
            <button className="next-btn" onClick={() => handleClickNext()}>
              {loading ? <div className="upload_loader-two"></div> : "Buy Plot"}
            </button>
          </div>
        </div>
      )}
    </Fragment>
  );
}

export default BuyerPopup;
